<template>
  <div class="app__content section">
    <div class="section__wrapper">
      <div class="section__content">
        <h2 class="">Uploader</h2>
        <form class="form" @submit.prevent="submit()">
          <div class="form__group">
            <p>Please log in</p>
            <div class="form__input-group form__input-group--full form__input-group--wrap">
              <label class="form__label--hidden" for="email">Email</label>
              <input :class="{ 'form__input--error': authError }" class="form__input" name="email" type="email" v-model="auth.username" placeholder="Email">

              <label class="form__label--hidden" for="password">Password</label>
              <input :class="{ 'form__input--error': authError }" class="form__input" name="password" type="password" v-model="auth.password" placeholder="Password">

              <button type="submit" class="button form__submit">
                  Log in
              </button>

              <router-link class="form__link" :to="'password-reset'">Forgotten password?</router-link>
            </div>
            <p class="form__help--error mr-2" v-if="authMessage">{{ authMessage }}</p>
            <router-link class="form__link" :to="'register'">Register</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Login, GetCurrentUser } from '@/services/api';
import { mapActions } from 'vuex';

export default {
  name: 'login',
  data() {
    return {
      auth: {
        username: '',
        password: '',
      },
      authError: false,
      authMessage: false,
    };
  },
  methods: {
    ...mapActions(['setUser']),
    submit() {
      if (this.auth.username && this.auth.password) {
        this.authError = false;
        this.authMessage = false;
        Login(this.auth).then((res) => {
          if (res.ok) {
            GetCurrentUser().then((data) => {
              this.setUser(data.data);
              this.$router.push({ name: 'view-upload' });
            });
          }
        })
        .catch((err) => {
          this.authError = true;
          if (err.status === 401) this.authMessage = 'Incorrect username or password';
          else this.authMessage = err.body.message;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// login.vue?9229fa54